const variables = {
  logo: 'Positive',
};

export default variables;
